import React from 'react';

import PropTypes from 'prop-types';

import * as Yup from 'yup';
import {
  Formik, Form as FormikForm,
} from 'formik';

import { Row, Col } from 'react-bootstrap';

import {
  TextAreaField,
  SubmitButton,
  CancelPopupButton,
} from 'ui/FormElement';

export default function Form({ prompt, onSave, onClose }) {
  const formSchema = Yup.object().shape({
    message: Yup.string().required('Message is required'),
  });

  const onSubmit = (values, { setSubmitting, setErrors }) => {
    const onSuccess = () => {
      setSubmitting(false);
    };

    const onError = (errorData) => {
      const newErrors = {};
      errorData.errors.forEach((item) => {
        newErrors[item.source.replace('/data/attributes/', '')] = item.detail;
      });
      setErrors(newErrors);
      setSubmitting(false);
    };

    onSave(values, onSuccess, onError);
  };

  return (
    <Formik
      enableReinitialize
      validationSchema={formSchema}
      initialValues={prompt}
      onSubmit={onSubmit}
    >
      {({ isSubmitting }) => (
        <FormikForm className="needs-validation" noValidate="">
          <TextAreaField
            name="message"
            label={(
              <>
                <span>Message</span>
                <abbr title="required">*</abbr>
              </>
                  )}
          />

          <Row className="mt50 mb30">
            <Col md={6}>
              <CancelPopupButton
                className="btn btn-primary btn-outline mr5 ml5 width-120"
                title="Cancel"
                onClick={onClose}
              />
            </Col>
            <Col md={6} className="text-right">
              <SubmitButton
                title={isSubmitting ? 'Please, wait ...' : 'Save'}
                className={`btn width-120 btn-primary submit-button mr5 ml5 ${
                  isSubmitting ? 'not-possible-click' : ''
                }`}
              />
            </Col>
          </Row>
        </FormikForm>
      )}
    </Formik>
  );
}

Form.propTypes = {
  prompt: PropTypes.object.isRequired,
  onSave: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};
